import { Box } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { useIntl } from "react-intl";
import NotificationConfigurationForm, {
  NotificationConfigFormMode,
} from "./NotificationConfigurationForm";

const NotificationConfigurationCreateForm = () => {
  const { formatMessage: t } = useIntl();
  const { notificationConfigurationsUrl } = useGlobalContext();

  useTitle(t({ id: "createNotificationConfiguration" }));

  return (
    <Box>
      <RedirectBackButton
        redirectRoute={notificationConfigurationsUrl()}
        labelKey="backToNotifications"
      />
      <h2>{t({ id: "createNotificationConfiguration" })}</h2>
      <NotificationConfigurationForm mode={NotificationConfigFormMode.Create} />
    </Box>
  );
};

export default NotificationConfigurationCreateForm;
